export const SUBMIT_PARTNER_SIGNUP_FORM = 'action.partnerSignup.submit';
export const RESEND_PARTNER_EMAIL = 'action.partnerSignup.resend-email';
export const SET_PARTNER_SIGNUP_STATUS = 'action.partnerSignup.set.status';
export const SET_PARTNER_SIGNUP_IS_LOADING = 'action.partnerSignup.set.is-loading';
export const SET_PARTNER_SIGNUP_EMAIL_SENT = 'action.partnerSignup.set.email-sent';

export const submitPartnerSignupForm = data => ({
    type: SUBMIT_PARTNER_SIGNUP_FORM,
    data,
});

export const resendPartnerConfirmationEmail = email => ({
    type: RESEND_PARTNER_EMAIL,
    data: { email },
});

export const setPartnerSignupStatus = (status, errorCode) => ({
    type: SET_PARTNER_SIGNUP_STATUS,
    status,
    errorCode,
});

export const setPartnerSignupIsLoading = isLoading => ({
    type: SET_PARTNER_SIGNUP_IS_LOADING,
    isLoading,
});

export const setPartnerSignupEmailSent = emailSent => ({
    type: SET_PARTNER_SIGNUP_EMAIL_SENT,
    emailSent,
});